window.addEventListener("DOMContentLoaded", () => {
    let announcementBar = document.querySelector(
        "#shopify-section-announcement-bar .announcement-bar.top"
    );

    let announcementItems = document.querySelectorAll(".announcement-bar");

   function headerAnnouncementOffset() {
    let offset = 0;
    if (announcementBar) {
        offset = announcementBar.offsetHeight;
    }

    const stickyHeader = document.querySelector(".sticky-header"); // Update selector if needed
    if (stickyHeader) {
        stickyHeader.style.top = offset + "px";
    }

    const mainContent = document.querySelector("#MainContent");
    if (mainContent) {
        mainContent.style.top = offset + "px";
        mainContent.style.marginBottom = offset + "px";
    }

    const mainMenu = document.querySelector(".mainMenu");
    if (mainMenu) {
        mainMenu.style.marginTop = window.innerWidth <= 960 ? offset + "px" : "0px";
    }

    const productTitle = document.querySel

    }

    if (announcementBar) {
        headerAnnouncementOffset();
        document.body.classList.add("announce-top");
        window.addEventListener("resize", headerAnnouncementOffset);

        const announcementWrapper = document.querySelector(".announcement-bar__outer");
        if (announcementItems.length > 1) {
            new Swiper(announcementWrapper, {
                slidesPerView: 1,
                speed: 800,
                spaceBetween: 0,
                autoplay: announcementWrapper.classList.contains("autoplay")
                    ? {
                        delay: 5000, // 3 seconds
                        disableOnInteraction: false,
                      }
                    : false,
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        }
    }
});
